/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { Component, Fragment } from "react";
import ImgBitmapCss from "./ImgBitmap.css";

class ImgBitmap extends Component {
  constructor(props) {
    super(props);

    this.imgHandle = null;
    this.imgLoader = new Image();
  }

  laodBitmapUsingImageLoader = () => {
    let { onImageLoaded, src } = this.props;

    if (src) {
      if (!this.imgLoader.src) {
        this.imgHandle && (this.imgHandle.style.display = "none");
      }
      this.imgLoader.src = src;
      this.imgLoader.onload = () => {
        if (this.imgHandle && src === this.imgLoader.src) {
          this.imgHandle.src = src;
          this.imgHandle.style.display = "block";
          if (onImageLoaded) {
            onImageLoaded();
          }
        }
      };
    } else if (this.imgHandle) {
      this.imgHandle.src = "";
      this.imgHandle.style.display = "none";
    }
  };

  componentDidMount() {
    this.laodBitmapUsingImageLoader();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.src !== prevProps.src) {
      this.laodBitmapUsingImageLoader();
    }
  }

  render() {
    return (
      <Fragment>
        <img
          id={this.props.id}
          aria-hidden="true"
          className={ImgBitmapCss.image}
          style={this.props.style}
          draggable="false"
          alt=""
          ref={handle => (this.imgHandle = handle)}
        />
      </Fragment>
    );
  }
}

export default ImgBitmap;
